export default __webpack_public_path__ + "static/img56h-256175410cef303a1b88b661e69d0e81.jpg";